import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import Drawer from '@zenbusiness/zui/Drawer';
import IconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import PropTypes from 'prop-types';

export default function CustomizedDrawer({ handleClose, children }) {
  return (
    <Drawer
      anchor="right"
      onClose={handleClose}
      open
      sx={{ zIndex: 10000 }}
    >
      <DialogTitle
        display="flex"
        justifyContent="end"
      >
        <IconButton
          label=""
          onClick={handleClose}
          size="small"
        >
          <SharedAsset
            alt=""
            height={20}
            src="/icon/micro/close-x.svg"
            width={20}
          />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ width: 477 }}>{children}</DialogContent>
    </Drawer>
  );
}

CustomizedDrawer.propTypes = {
  handleClose: PropTypes.func,
  children: PropTypes.node
};
